import React from "react";
import _get from "lodash-es/get";
import classNames from "classnames";
import T from "src/ipm-shared/Utils/Intl";

import InputText from "src/bepaid/components/Form/controls/InputText";
import Checkbox from "src/bepaid/components/Checkbox";

import SearchCompanyForm from "src/bepaid/components/SearchCompanyForm";
import Divider from "antd/es/divider";
import Form from "src/bepaid/components/Form";
import HasFieldError from "src/ipm-shared/components/Form/helpers/HasFieldError";

import styles from "../../RecipientModal.module.scss";
import InputMobile from "src/bepaid/components/Form/controls/InputMobile";
import CountryUtil from "src/ipm-shared/Utils/Country";

const DomesticRecipientSupplierFormContent = ({
  editedPayee,
  FORM,
  initName,
  inputUEN,
  inputSearch,
  isSupplierPayoutUEN,
  editMode,
  countryId,
  isBusinessAccount
}: any) => {
  const designatedRegistrationNumber = _get(
    editedPayee,
    "data.designated_registration_number",
    ""
  );
  const registrationNumber = _get(editedPayee, "data.registration_number");
  const isCheckedDesignatedSupplier = editMode
    ? designatedRegistrationNumber === registrationNumber
    : true;
  const isSG = countryId === CountryUtil.getCountryIdFromCountryCode("SG");
  const isSGPersonal = isSG && !isBusinessAccount;

  return (
    <Form
      name="company-form"
      layout="vertical"
      requiredMark={false}
      className={styles.companyForm}
    >
      <div>
        <span className={styles.additionalInfoLabel}>Contact details</span>
        <Divider />

        <SearchCompanyForm
          form={FORM}
          {...(isSupplierPayoutUEN && {
            designatedSupplierCheckbox: (
              <Checkbox
                className={styles.designatedSupplierCheckbox}
                id="designated_supplier_checkbox"
                name={"designated_supplier_checkbox"}
                presentedValue="checked"
                defaultChecked={isCheckedDesignatedSupplier}
                form={FORM}
                label={"is the supplier's UEN the designated UEN number?"}
              />
            )
          })}
          supplierOptInCheckBox={
            <Checkbox
              className={styles.supplierOptInCheckBox}
              id="supplier_opt_in"
              name={"supplier_opt_in"}
              presentedValue="checked"
              defaultChecked={true}
              form={FORM}
              label={T.transl("INTEND_MULTIPLE_PAYMENTS_LABEL")}
            />
          }
          fields={{
            autoCompleteField: {
              name: "recipient_name", // "uen_search_company"
              default: _get(editedPayee, "name") || initName,
              ...inputSearch
            },
            inputTextField: {
              name: "registration_number",
              ...inputUEN
            }
          }}
          input={{
            companyName: _get(editedPayee, "name") || initName,
            registrationNumber,
            designatedRegistrationNumber
          }}
          shouldDisplayRegField={false}
          editMode={editMode}
        />

        <InputText
          name={"recipient_contact_name"}
          placeholder={"Supplier contact name"}
          form={FORM}
          label={"Supplier contact name"}
          defaultValue={_get(editedPayee, "data.recipient_contact_name", "")}
          // {...commonFormItemProps}
          // className={styles.codeSection}
        />
        <InputText
          name={"recipient_email"}
          placeholder={"Supplier contact email"}
          form={FORM}
          label={"Supplier contact email"}
          defaultValue={_get(editedPayee, "data.recipient_email", "")}
          // {...commonFormItemProps}
          // className={styles.codeSection}
        />

        {isSGPersonal && (
          <HasFieldError name="recipient_mobile" form={FORM}>
            {errors => {
              const mobileHasError = errors.length > 0;

              return (
                <>
                  <InputMobile
                    form={FORM}
                    name="recipient_mobile"
                    nameCode="recipient_mobile_country_code"
                    placeholder={`Supplier contact number`}
                    label={
                      <p>
                        Supplier contact number (optional
                        <span className={styles.asterisk}>*</span>)
                      </p>
                    }
                    defaultValue={_get(
                      editedPayee,
                      "data.recipient_mobile",
                      ""
                    )}
                    code={CountryUtil.getCountryCodeFromCountryId(
                      _get(
                        editedPayee,
                        "data.recipient_mobile_country_id",
                        countryId
                      )
                    )}
                  />
                  <p
                    className={classNames(styles.mobileNumberNote, {
                      [styles.mobileNumberNoteSpaced]: mobileHasError
                    })}
                  >
                    <span className={styles.asterisk}>*</span>
                    Supplier contact number is required for AMEX card payments.
                  </p>
                </>
              );
            }}
          </HasFieldError>
        )}

        <div hidden={true}>
          <Checkbox
            presentedValue={"invoice_notify"}
            id="invoice_notify"
            name="should_notify_recipient_initiated"
            form={FORM}
            label={T.transl("NOTIFY_SUPPLIER_CHECKBOX")}
            defaultChecked={true}
          />
        </div>
      </div>
    </Form>
  );
};

export default DomesticRecipientSupplierFormContent;
